/**
 * Navigators
 */
/**
 * @deprecated Reserved for libraries that ship a self-contained navigator, which the `Stack` layout
 * cannot express. There is no stable replacement yet, so expect this factory to change or be removed
 * in a future release. App code should use `Stack` from `expo-router`.
 */
export { createNativeStackNavigator } from './navigators/createNativeStackNavigator';

/**
 * Views
 */
export { NativeStackView } from './views/NativeStackView';

/**
 * Hooks
 */
export { useAnimatedHeaderHeight } from './utils/useAnimatedHeaderHeight';

/**
 * Types
 */
export type {
  NativeStackHeaderBackProps,
  NativeStackHeaderItem,
  NativeStackHeaderItemButton,
  NativeStackHeaderItemCustom,
  NativeStackHeaderItemMenu,
  NativeStackHeaderItemMenuAction,
  NativeStackHeaderItemMenuSubmenu,
  NativeStackHeaderItemProps,
  NativeStackHeaderItemSpacing,
  NativeStackHeaderLeftProps,
  NativeStackHeaderProps,
  NativeStackHeaderRightProps,
  NativeStackHeaderNativeProps,
  NativeStackNativeProps,
  NativeStackNavigationEventMap,
  NativeStackNavigationOptions,
  NativeStackNavigationProp,
  NativeStackNavigatorProps,
  NativeStackOptionsArgs,
  NativeStackScreenNativeProps,
  NativeStackScreenProps,
} from './types';
